export const COMMENT_STYLES = {
  funny: {
    label: 'Funny',
    description: 'Humorous and playful, uses wit and light jokes',
  },
  serious: {
    label: 'Serious',
    description: 'Thoughtful and professional, focuses on meaningful insights',
  },
  sly: {
    label: 'Sly',
    description: 'Clever and witty, subtly playful with a knowing tone',
  },
  supportive: {
    label: 'Supportive',
    description: 'Encouraging and positive, offers genuine support',
  },
  curious: {
    label: 'Curious',
    description: 'Inquisitive and engaging, asks thoughtful questions',
  },
  analytical: {
    label: 'Analytical',
    description: 'Critical thinking and insightful observations',
  },
  casual: {
    label: 'Casual',
    description: 'Relaxed and laid-back, conversational tone',
  },
  enthusiastic: {
    label: 'Enthusiastic',
    description: 'Excited and energetic, shows passion and interest',
  },
} as const

export type CommentStyle = keyof typeof COMMENT_STYLES
